import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/index',
      name: 'home',
      alias: '/',
      component: () => import('@/views/home/index.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/product/index.vue'),
      meta: {
        title: '产品'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index.vue'),
      meta: {
        title: '关于'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/news/index.vue'),
      meta: {
        title: '资讯'
      }
    },
    {
      path: '/news/detail',
      name: 'news-detail',
      component: () => import('@/views/news/detail.vue'),
      meta: {
        title: '资讯'
      }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('@/views/services/index.vue'),
      meta: {
        title: '服务'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js